import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { FundaBanner } from "./FundaBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const PAGE_CONFIG: Record<
  string,
  { imageSrc: string; imagePosition?: string; imageScale?: string }
> = {
  advice: {
    imageSrc:
      "https://nuxt.fstatic.nl/9b1861e964621086/makelaar-zoeken/_nuxt/computer-table.C8P_zret.svg",
  },
  documentsOutgoing: {
    imageSrc:
      "https://nuxt.fstatic.nl/9b1861e964621086/makelaar-zoeken/_nuxt/folder-house-keys.BrkniHDv.svg",
    imagePosition: "center center",
    imageScale: "0.8",
  },
  documentsIncoming: {
    imageSrc:
      "https://nuxt.fstatic.nl/9b1861e964621086/makelaar-zoeken/_nuxt/folder-house-keys.BrkniHDv.svg",
    imagePosition: "center center",
    imageScale: "0.8",
  },
  interestRates: {
    imageSrc:
      "https://nuxt.fstatic.nl/9b1861e964621086/makelaar-zoeken/_nuxt/computer-table.C8P_zret.svg",
  },
  maximumMortgage: {
    imageSrc:
      "https://nuxt.fstatic.nl/eecf9a6ac9bc47c8/mijn-huis/_nuxt/couch-and-plant.80w8j5_f.svg",
  },
  orientation: {
    imageSrc: "https://assets.fstatic.nl/shared/images/funda_header.svg",
    imagePosition: "left bottom",
    imageScale: "1.5",
  },
};

export const FundaPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();
  const config = PAGE_CONFIG[scope];

  return (
    <FundaBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={config?.imageSrc ?? ""}
      imagePosition={config?.imagePosition}
      imageScale={config?.imageScale}
    />
  );
};
